import { useField } from 'formik';
import { TextField } from 'src/components/TextField';
import { timeZones } from 'src/utils/time-zones';

interface TimezoneSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

interface FormTimezoneSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
  value,
  onChange,
  label = 'Timezone',
  placeholder = 'Select Timezone',
  disabled = false,
  error,
  helperText,
}) => {
  const options = [
    { value: '', label: placeholder, disabled: true },
    ...timeZones.map((timezone) => ({
      value: timezone.value,
      label: timezone.name,
    })),
  ];

  return (
    <TextField
      label={label}
      error={error}
      helperText={helperText}
      disabled={disabled}
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const FormTimezoneSelect: React.FC<FormTimezoneSelectProps> = ({
  name,
  label,
  placeholder,
  disabled,
}) => {
  const [field, meta] = useField({ name });

  return (
    <TimezoneSelect
      value={field.value || ''}
      onChange={(value) => field.onChange({ target: { name, value } })}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched ? meta.error : undefined}
    />
  );
};
